<template>
	<section style="height: 100%;">
		<div class="col" style="height: 100%;">
			<div class="row" style="height: 100%;">
				<div class="col-lg-5">
					<ValidationObserver tag="form" v-slot="{ invalid }" onsubmit="return false" class="mx-auto col-lg-10">
						<router-link to="/login"><i class="fa fa-arrow-left" style="margin-top: 50px;"></i></router-link>
						<h4 class="mb-4 mt-4"><b>Lupa Kata Sandi</b></h4>
						<div class="alert alert-danger f-12" v-if="authFalse">
							{{ errors }}
						</div>

						<p class="f-14 text-secondary">Masukkan alamat email Anda dan kami akan mengirimkan instruksi untuk mereset kata sandi Anda</p>
						<ValidationProvider name="Email" rules="required|email">
							<div class="form-group" slot-scope="{ errors }">
								<label class="form-label f-14">Email</label>
								<input type="email" v-model="email" class="form-control" :class="{ 'error': errors[0] || authFalse }" placeholder="Masukkan email">
								<div class="f-12 text-danger">{{ errors[0] }}</div>
							</div>
						</ValidationProvider>
						<button :disabled="invalid" @click="resetPassword" class="btn btn-primary w-100 f-14 pd-10-20 mt-3">Kirim</button>
					</ValidationObserver>
				</div>
				<div class="d-none d-lg-block col-7"
					style="
						background-image: url('/img/login.png');
						background-color: #FFA827;
						background-repeat: round;
						height: 100%;
					">
					<div class="vertical-center" style="top:50%;">
						<img src="/img/login-1.png" alt="">
						<p class="text-white">Check every shipment easily</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	data() {
        return {
            email: null,
            authFalse: false,
			errors: null
        }
    },
    methods: {
        resetPassword() {
            let _ = this
            _.axios.post('/auth/forgot_password', { email: _.email })
                .then(resp=>{
                    if ( resp.data ) {
                        _.$router.push('lupa-password-confirm')
                    }
                })
                .catch(err=>{
                    _.authFalse = true
					_.errors = err.response.data.message
                })
        }
    }
}
</script>